import React, { useEffect } from 'react';

export default function ShowContainer({
  condition,
  children,
  successCondition = () => {},
  errorCondition = () => {},
  plug = <></>,
  alwaysJSX,
  style
}) {
  useEffect(() => {
    if (condition) successCondition?.();
    if (!condition) errorCondition?.();
  }, [condition]);

  if (alwaysJSX) {
    return (
      <div style={{ opacity: +condition, pointerEvents: condition ? '' : 'none', ...style }}>
        {children}
      </div>
    );
  }

  return condition ? <>{children}</> : <>{plug}</>;
}
